<template>
    <div id="app">
        <Header/>
        <router-view/>
        <Footer/>
    </div>
</template>
<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";

    export default {
        components: {Footer, Header}
    }
</script>
<style>
    .no-data {
        color: rgb(153, 153, 153);
        text-align: center;
        margin: 100px auto;
        font-size: 16px;
    }
</style>